import axios from "axios";
import { API_URL } from '../config/api.config';

const api = axios.create({
  baseURL: API_URL,
});

// const api = axios.create({
//   baseURL: "https://api.toursbouillon.fr/api",
// });

// Fonction pour gérer les erreurs
const handleError = (error) => {
  if (error.response) {
    // Le serveur a répondu avec un code d'erreur
    return error.response.data;
  } else if (error.request) {
    // La requête a été faite mais pas de réponse
    return "Impossible de contacter le serveur";
  } else {
    // Une erreur s'est produite lors de la configuration de la requête
    return "Une erreur s'est produite";
  }
};

// Authentification
export const login = async (email, password) => {
  try {
    const response = await api.post("/auth/login", { email, password });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

// export const register = async (userData) => {
//   try {
//     const response = await api.post("/auth/register", userData);
//     return response.data;
//   } catch (error) {
//     throw handleError(error);
//   }
// };

// Gestion du token
export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("token");
  }
};

// Vérifier si l'utilisateur est connecté
export const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  return !!token;
};

// Déconnexion
export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  delete api.defaults.headers.common["Authorization"];
};
